import {AppBar, Toolbar, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import UserInfo from "./UserInfo";
import {drawerWidth} from "@/styles";
import {useMatches} from "react-router";
import {DocumentsIconButton} from "./documents/IconButton";
import Breadcrumb from "./breadcrumbs/Breadcrumb";
import {Link} from "./widgets";

const useStyles = makeStyles()({
    root: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
    },
});

function Header() {
    const {classes} = useStyles();
    const matches = useMatches();

    const crumbs = matches
        // get rid of matches that don't have handle and crumb
        .filter((match) => Boolean(match.handle && (match.handle as any).crumb))
        // map to crumbs, passing params
        // FIXME ideally we could pass the data aquired by the loader and then the variable crumbs would not need to
        // query display names
        .map((match) => (
            <Breadcrumb key={match.id}>
                <Link to={match.pathname}>{(match.handle as any).crumb(match.params)}</Link>
            </Breadcrumb>
        ));

    return (
        <AppBar position="fixed" color="default" className={classes.root}>
            <Toolbar>
                <Typography variant="h6" noWrap>
                    <div style={{display: "flex"}}>{crumbs || ""}</div>
                </Typography>
                <div style={{flexGrow: 1}} />
                <DocumentsIconButton />
                <span style={{width: 10}} />
                <UserInfo />
            </Toolbar>
        </AppBar>
    );
}

export default Header;
